<ng-container *ngIf="!!cardDetail">
<div class="cds-modal-header">
  <div class="left-section">
    <app-card-art [pid]="cardDetail.PID" [enablePdpLink]="false" [linkHref]="cardDetail.learnMoreLink"
      [defaultSize]="'tiny'"></app-card-art>
  </div>
  <div class="right-section">
    <h2 class="cds-modal-title" [innerHtml]="cardDetail.cardName"
      [attr.aria-label]="cardDetail.cardName | adaFriendlyName: 'ariaLabel'"></h2>
    <ui-card-rating class="ui-card-right-section" [pid]="cardDetail.PID" [scrollToSection]="false"
      [title]="cardDetail.cardName | adaFriendlyName: 'ariaLabel'" featureId="Review-modal-" [disableReviewModal]="true"
      (handleReviewClick)="(handleReviewClick)"></ui-card-rating>
  </div>
</div>
<div class="cds-modal-body">
  <div class="prlegend" [innerHtml]="cardDetail.prlegend"></div>
  <div class="reviewswrap">
    <div class="p-w-r">
      <div class="pr-review-display" [ngClass]="{'pr-rd-display-desktop': desktopScreen}">
        <header id="pr-rd-main-header" class="pr-rd-main-header">
          <h3 class="pr-rd-review-total pr-h1">Displaying Reviews</h3>
          <div class="pr-rd-right">
            <div class="pr-rd-sort-group text-right">
              <label for="pr-rd-sort-by" class="sr-only">Sort reviews by:</label>
              <select id="pr-rd-sort-by" class="pr-rd-sort" (change)="callSortedReviewPage($event)">
                <optgroup label="Sort reviews by:">
                  <option *ngFor="let item of reviewFilters" [value]="item.value" [innerHTML]="item.label"
                    [selected]="item.value === sortedReview">Most Recent</option>
                </optgroup>
              </select>
            </div>
          </div>
        </header>
        <div class="customer-review-box">
          <div class="pr-review" *ngFor="let review of cardDetail?.reviews;let review_index=index;">
            <header class="pr-rd-header pr-rd-content-block">
              <h3 tabindex="0" [attr.data-testid]="'headline-'+review.details.internal_review_id"
                [id]="'pr-rd-review-headline-'+review.details.headline" lang="en"
                class="pr-rd-review-headline pr-h2 {{'review-'+review_index}}" [innerHtml]="review.details.headline">
              </h3>
              <ui-card-rating [reviewCount]="review.metrics.rating.toString()" hideCount="true" [pid]="cardDetail.PID"
                [title]="cardDetail.cardName | adaFriendlyName: 'ariaLabel'" featureId="Review-modal-"
                class="ui-card-class">
              </ui-card-rating>
            </header>
            <section class="pr-rd-description pr-rd-content-block">
              <div class="pr-rd-side-content-block pr-rd-right modal-content-right">
                <div class="pr-rd-reviewer-details pr-rd-inner-side-content-block">
                  <p class="pr-rd-details pr-rd-author-submission-date">
                    <span class="pr-rd-bold">Submitted </span><time datetime="review.details.updated_date"
                      [innerHTML]="review.details.updated_date">8 days ago</time>
                  </p>
                  <p class="pr-rd-details pr-rd-author-nickname">
                    <span><span class="pr-rd-bold">By&nbsp;</span><span
                        [innerHTML]="review.details.nickname"></span></span>
                  </p>
                </div>
                <p class="pr-rd-description-text modal-description-text" lang="en" [innerHTML]="review.details.comments"></p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="pr-rd-pagination-block">
      <p class="pr-rd-review-position">
        <span>Displaying Reviews </span><span class="pr-rd-bold" [innerHTML]="cardDetail?.paging?.counter"></span>
      </p>
      <a href="javascript:void(0);" class="pr-rd-to-top pr-underline" aria-label="Back to Top"
        (click)="backToTop();">Back to Top</a>
      <div class="pr-rd-pagination">
        <a *ngIf="cardDetail?.paging?.current_page_number > 1" href="javascript:void(0)"
          (click)="callAnotherReviewPage(cardDetail?.paging?.previous_url)" class="pr-rd-pagination-btn"
          aria-label="Previous ratings and reviews">« Previous </a>
        <span
          *ngIf="cardDetail?.paging?.current_page_number > 1 && cardDetail?.paging?.current_page_number != cardDetail?.paging?.pages_total">|</span>
        <a *ngIf="cardDetail?.paging?.current_page_number != cardDetail?.paging?.pages_total" href="javascript:void(0)"
          (click)="callAnotherReviewPage(cardDetail?.paging?.next_page_url)" class="pr-rd-pagination-btn"
          aria-label="Next ratings and reviews"> Next »</a>
      </div>
    </div>
  </div>
</div>
<div class="cds-modal-footer">
  <p class="pr-disclaimer" [innerHtml]="cardDetail.prdisclaimer"></p>
</div>
</ng-container>
